export const CONFIG_FILE_URL = '/config/application.json';
